export function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 prose prose-invert prose-zinc">
      <h1>Terms of Service</h1>
      <p>Last updated: 2026-05-07</p>

      <h2>Service</h2>
      <p>
        OnlyBans provides a curated blocklist database and a browser extension
        that helps you mass-block accounts on X (Twitter) using your existing
        X session.
      </p>

      <h2>Your account</h2>
      <p>
        Sign-in is via Google. You are responsible for keeping your Google
        account secure. We may revoke service for abuse (e.g. attempting to
        block accounts on behalf of someone whose X session you don't own).
      </p>

      <h2>X / Twitter terms</h2>
      <p>
        OnlyBans operates within your X session, the same way clicking
        "Block" on X's website does. You are responsible for complying with
        X's Terms of Service when using OnlyBans. Excessive block volume may
        cause X to rate-limit your account; the extension throttles requests
        to mitigate this.
      </p>

      <h2>Subscription</h2>
      <p>
        OnlyBans is a paid service. During the demo phase, payment is
        coordinated via instant messaging and activated manually. Refund
        policy: contact us within 7 days of activation for a full refund.
      </p>

      <h2>Liability</h2>
      <p>
        OnlyBans is provided "as is". We are not affiliated with X Corp.
      </p>
    </div>
  )
}
